import React from 'react';
export function Audience() {
  const audiences = [{
    icon: '🚀',
    title: 'Arrancás desde cero',
    desc: 'Nunca vendiste joyas. No tenés proveedores, ni clientes, ni experiencia. Exactamente para eso está armado el sistema.'
  }, {
    icon: '💼',
    title: 'Querés independencia económica',
    desc: 'Tu sueldo no alcanza, perdiste el trabajo o querés un ingreso propio que no dependa de nadie más.'
  }, {
    icon: '🏠',
    title: 'Trabajás desde tu casa o barrio',
    desc: 'Sin local, sin empleados, sin gran inversión inicial. Solo un celular, un proveedor y las herramientas del sistema.'
  }, {
    icon: '📊',
    title: 'Ya vendés pero sin orden',
    desc: 'Hacés ventas sueltas pero no sabés bien si ganás, no tenés registro y no podés escalar porque no hay sistema.'
  }, {
    icon: '🌟',
    title: 'Querés construir una marca',
    desc: 'No solo vender, sino tener un nombre en redes, clientes que te buscan a vos y un negocio que crezca solo.'
  }, {
    icon: '🗺️',
    title: 'Estás en cualquier punto del país',
    desc: 'Buenos Aires, Córdoba, Rosario, Mendoza, el interior. El directorio de proveedores y ferias cubre todo el territorio.'
  }];
  return <section className="bg-gold/5 py-12 sm:py-20" data-id="element-1">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-2">
        <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-3">
          ¿Para quién es?
        </div>
        <h2 className="mb-4 font-serif text-[clamp(24px,4vw,38px)] font-bold leading-[1.2] text-white" data-id="element-4">
          Diseñado para vos si querés un negocio real de joyas y oro
        </h2>
        <p className="mb-8 sm:mb-12 max-w-[560px] text-[15px] text-text" data-id="element-5">
          No importa si nunca vendiste nada. El sistema empieza desde cero y
          lleva hasta clientes fijos.
        </p>

        <div className="mb-6 flex flex-col gap-3" data-id="element-6">
          {audiences.map((aud, i) => <div key={i} className="flex items-start gap-4 rounded-xl border border-border bg-card p-4 transition-colors duration-300 hover:border-gold/40 sm:items-center sm:p-5" data-id="element-7">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/20 bg-gold/10 text-[22px]" data-id="element-8">
                {aud.icon}
              </div>
              <div className="flex-1" data-id="element-9">
                <div className="mb-1 text-[14px] font-semibold text-white" data-id="element-10">
                  {aud.title}
                </div>
                <div className="text-[12px] leading-[1.6] text-muted" data-id="element-11">
                  {aud.desc}
                </div>
              </div>
            </div>)}
        </div>

        <p className="text-center text-[13px] text-muted" data-id="element-12">
          ¿No estás seguro si es para vos? Tenés{' '}
          <a href="https://solucionesya.shop/cart/48819517128952:1" target="_blank" rel="noopener noreferrer" className="text-gold no-underline" data-id="element-13">
            7 días de garantía →
          </a>
        </p>
      </div>
    </section>;
}